import React, { useEffect } from "react";
import "./generic.css";
import { IButton } from "./button.d";
import { getImage } from "./functions";

const Button: React.FC<IButton> = (props) => {
    return (
        <button 
            onClick={props.onClick}
            className={`props ${props.size} ${props.classProp}`}
            type="submit"
        >            
            {props.hasIcon && props.src! !== null && (
                <img 
                    className="button_img"
                    src={getImage(props.src!)} 
                    alt={props.src}
                />
            )}
            {props.label}
        </button>
    );
  };
  export default Button;